<template>
  <div
    v-click-outside="handleFocusOut"
    class="help-center-dropdown"
  >
    <div
      id="central-de-ajuda"
      class="icon-header-decoration"
    >
      <button
        class="help-center-dropdown__icon"
        :class="{ 'is-open': isOpen }"
        @click="isOpen = !isOpen"
      >
        <svg-loader
          src="/static/images/icon-help-basic-purple.svg"
          class="i-donwloads"
        />
      </button>
      <md-tooltip
        md-delay="400"
        md-direction="right"
      >
        Central de Ajuda
      </md-tooltip>
    </div>
    <transition name="dropdown">
      <div
        v-show="isOpen"
        class="help-center-dropdown__list"
      >
        <h6
          :class="{ active: isHelpCenterPage }"
          @click="goToHelpCenterPage()"
        >
          <md-icon md-src="/static/images/icon-help-basic-purple.svg" />
          Central de Ajuda
        </h6>
        <template v-if="helpCenterList.length > 0">
          <span>Saiba Mais</span>
          <ul>
            <li
              v-for="(item, index) in helpCenterList"
              :key="index"
              @click="doIt(item.tutorial, item.action)"
            >
              <md-icon :md-src="'/static/images/' + item.icon + '.svg'" />
              {{ item.text }}
            </li>
          </ul>
        </template>

        <ul>
          <li
            v-for="(item, indexNews) in helpCenterNews"
            :key="indexNews"
            @click="doIt(item.tutorial, item.action)"
          >
            <template v-if="!item.toggle || !toggle[item.toggle]">
              <md-icon :md-src="'/static/images/' + item.icon + '.svg'" />
              {{ item.text }}
            </template>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import { clickOutside } from '@/utils/directives'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'HelpCenterDropdown',
  data() {
    return {
      isOpen: false,
      isHelpCenterPage: false,
      helpCenterList: [],
      helpCenterNews: [
        {
          icon: 'helpcenter-lamp',
          text: 'Rastreabilidade de amostras',
          tutorial: 'rastreabilityModal',
          action: true,
          toggle: false,
        },
        {
          icon: 'helpcenter-lamp',
          text: 'Novo sistema de impressão',
          tutorial: 'printAlert',
          action: 'openPrintAlert',
          toggle: false,
        },
      ],
    }
  },
  methods: {
    ...mapActions(['updateTutorialsList']),
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Menu superior',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    handleFocusOut() {
      if (this.isOpen) {
        this.isOpen = false
      }
    },
    doIt(tutorial, action) {
      this.isOpen = false

      if (action === 'openPrintAlert') {
        window.open(
          'https://storageapoiob2bprd.blob.core.windows.net/printer-plugin/Manual_Instalacao_Plugin_Impressao_AOL20.pdf',
          '_blank'
        )
      } else {
        this.updateTutorialsList({ tutorial, action })
      }
    },
    goToHelpCenterPage() {
      this.isOpen = false
      this.$router.push('/central-de-ajuda')
      this.pushEventToAnalytics('Link Central de Ajuda')
    },
    changeHelpCenterList() {
      this.isHelpCenterPage = false
      const pathUrl = window.location.pathname
      if (pathUrl === '/central-de-ajuda') {
        this.isHelpCenterPage = true
      }

      if (pathUrl === '/dashboard') {
        this.helpCenterList = [
          {
            icon: 'helpcenter-popup',
            text: 'Tutorial da Tela Inicial',
            tutorial: 'tourOfCurrentPage',
            action: true,
            toggle: false,
          },
          {
            icon: 'helpcenter-popup',
            text: 'Buscar amostras',
            tutorial: 'busca',
            action: true,
            toggle: false,
          },
          {
            icon: 'helpcenter-popup',
            text: 'Contato pelo Whatsapp',
            tutorial: 'whatsapp',
            action: true,
            toggle: false,
          },
        ]
      } else if (pathUrl.includes('/print-tag/batches')) {
        this.helpCenterList = [
          {
            icon: 'helpcenter-lamp',
            text: 'Impressão de etiquetas',
            tutorial: 'printTagTutorial',
            action: true,
            toggle: false,
          },
        ]
      } else if (pathUrl.includes('/orders') && !pathUrl.includes('/orders/new')) {
        this.helpCenterList = [
          {
            icon: 'helpcenter-popup',
            text: 'Listagem de OS',
            tutorial: 'tourOfCurrentPage',
            action: true,
            toggle: false,
          },
        ]
      } else if (pathUrl.includes('/results')) {
        this.helpCenterList = [
          {
            icon: 'helpcenter-popup',
            text: 'Resultados de Exames',
            tutorial: 'tourOfCurrentPage',
            action: true,
            toggle: false,
          },
        ]
      } else {
        this.helpCenterList = []
      }
    },
  },
  computed: {
    ...mapGetters(['profile']),
  },
  watch: {
    $route(to, from) {
      this.changeHelpCenterList()
    },
  },
  mounted() {
    this.changeHelpCenterList()
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
    clickOutside,
  },
}
</script>
<style lang="scss">
.help-center-dropdown {
  position: relative;
  font-family: 'Exo 2';

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin: auto 4px;
    background-color: #fff;

    &:hover:not(.is-open) {
      background-color: rgba(22, 22, 22, 0.04);
    }

    &.is-open {
      background: #fcf2f8;

      i.md-icon {
        margin: 0 !important;
        text-align: center;
        display: flex;
        justify-content: center;

        path {
          fill: #840051;
        }
      }
    }

    i.md-icon {
      margin: 0 !important;
      text-align: center;
      display: flex;
      justify-content: center;

      svg {
        fill: #b2b2b2;
      }
    }
  }

  &__list {
    background-color: #fff;
    width: 272px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 18px;
    box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    position: absolute;
    top: 56px;
    right: 0;
    font-size: 14px;

    i.md-icon {
      width: 18px;
      min-width: 18px;
      height: 18px;
      min-height: 18px;
      font-size: 18px;
      margin: 0 !important;
      margin-right: 10px !important;
    }

    h6 {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: 600;
      font-size: 14px;
      color: #7f1a54;
      cursor: pointer;
      padding: 10px 10px 10px;
      border-radius: 3px;
      margin: -6px -9px 0;
      background: #fff;
      transition: all ease-in 0.1s;

      &:hover,
      &:focus,
      &.active {
        background: #fcf2f8;
      }
    }

    span {
      font-weight: 600;
      font-size: 10px;
      line-height: 11px;
      display: flex;
      text-transform: uppercase;
      color: #999999;
      margin: 16px 0 5px;
    }

    li {
      padding: 7px 10px;
      border-radius: 3px;
      margin: 0 -10px 0 !important;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      background-color: #fff;
      cursor: pointer;
      transition: all ease-in 0.1s;

      &:hover {
        background-color: rgba(22, 22, 22, 0.04);
      }

      a {
        flex-shrink: 1;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
